import { connect } from 'react-redux';

import {
  getLabels,
  getProjectOriginalZoneId,
  getProjectZoneId,
  getRevenueChartOptions,
  getRevenueEvents,
} from '../../reducers/analyticsApp';
import { views } from '../../constants/event';
import LabelsChart from './LabelsChart';

const show = (events, view) =>
  events.some(({ result }) => !!result.rows.length) && view === views.CHART;

const mapStateToProps = (state) => ({
  zoneId: getProjectOriginalZoneId(state),
  userZoneId: getProjectZoneId(state),
  labels: getLabels(state),
  from: getRevenueChartOptions(state).from,
  to: getRevenueChartOptions(state).to,
  show: show(getRevenueEvents(state), getRevenueChartOptions(state).view),
});

export default connect(mapStateToProps)(LabelsChart);
